import { API_DICTIONARY, HTTP_METHODS } from '../../../constants'
import Fetcher from '../../../services/Fetcher'
import {
  TAddBusinessAccountRequest,
  TBusinessDetails
} from './BankingSetup/types'

const fetcher = new Fetcher({})

export const getBusinessDetailsVendorOrganization = async (id: string) =>
  fetcher.request<unknown, TBusinessDetails>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${id}/`,
    method: HTTP_METHODS.GET
  })

export const setBusinessDetailsVendorOrganization = async (data) =>
  fetcher.request<TAddBusinessAccountRequest, unknown>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}`,
    method: HTTP_METHODS.POST,
    data
  })
